import { AfterViewInit, Component, Input, OnDestroy, OnInit } from '@angular/core';
// import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { HttpClient } from '@angular/common/http';
import { Subscription } from 'rxjs';
import { CommonModule } from '@angular/common';
@Component({
  selector: 'app-talktosales',
  templateUrl: './talktosales.component.html',
  styleUrls: ['./talktosales.component.scss'],
  imports: [CommonModule],
})
export class TalktosalesComponent implements OnInit, OnDestroy, AfterViewInit {
  @Input() hubspotId!:string;
  constructor(private http: HttpClient) {
    this.subscriptions = [];
  }

  public formValueChangeSubscription!: Subscription;
  subscriptions: Subscription[];
  submitSuccess: boolean = false;

  submittedValue: any;

  ngOnDestroy(): void {
    if (this.subscriptions && this.subscriptions.length > 0) {
      this.subscriptions.forEach(subscription => {
        subscription.unsubscribe();
      });
    }
    // this.formValueChangeSubscription.unsubscribe();
  }

  ngOnInit(): void {
    this.submitSuccess = false;
  }

  ngAfterViewInit() {
    try {
      // @ts-ignore
      if (typeof hbspt !== 'undefined') {
        // @ts-ignore
        hbspt.forms.create({
          region: 'na1',
          portalId: '8646839',
          formId: this.hubspotId ? this.hubspotId : '1172daac-f1fa-4a3c-a05f-07e13b4092f0',
          target: '#hubspotForm',
        });
      }
    } catch (_) {}
  }

  // get activeModal() {
  //   // return this._NgbActiveModal;
  // }
}
